import React from 'react';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import classes from './RuleTotalsPanel.module.css';

const RuleTotalsPanel = ({
    faultSummaryMeta,
    ...props
}) => {

    return (
        <div className={classes.RuleTotalsPanel}>
            <div className={classes.RulesContainer}>
                <div>
                    <p className={classes.Title}>Rules</p>
                    <p className={classes.Value}>{faultSummaryMeta.totalRuleCount}</p>
                </div>
                <div>
                    <p className={classes.Title}>Fault Occurrences</p>
                    <p className={classes.Value}>{faultSummaryMeta.totalActiveFaults}</p>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        faultSummaryMeta: state.bob.faultSummaryMeta
    };
};

export default withRouter(connect(mapStateToProps, null)(RuleTotalsPanel));

